// Ambil SEMUA baris menembus batas diam-diam PostgREST (default 1.000 baris). Tanpa ini, query
// uang/daftar besar terpotong tanpa error → angka salah tanpa ada yang sadar (memory postgrest-1000-row-cap).
// Pemakaian: fetchAllPaged((a,b) => supabase().from('x').select('...').eq(...).order('id').range(a,b))
// PENTING: sertakan .order(...) yang stabil sebelum .range() agar paging tak melewatkan/menggandakan baris.

type PagedResult<T> = { data: T[] | null; error: { message: string } | null };

export async function fetchAllPaged<T>(make: (dari: number, sampai: number) => PromiseLike<PagedResult<T>>): Promise<T[]> {
  const PAGE = 1000;
  const out: T[] = [];
  for (let dari = 0; ; dari += PAGE) {
    const { data, error } = await make(dari, dari + PAGE - 1);
    if (error) throw new Error(error.message);
    const hal = (data ?? []) as T[];
    out.push(...hal);
    if (hal.length < PAGE) break;
  }
  return out;
}

/**
 * Sama seperti `fetchAllPaged`, tapi untuk query `.in('kolom', daftar)` dengan daftar panjang.
 * Dua batas menjepit sekaligus di sini: `.in(...)` ikut masuk ke URL (ribuan nomor → permintaan
 * ditolak karena kepanjangan) DAN hasilnya tetap dipotong di 1.000 baris tanpa tanda. Jadi daftar
 * dipecah per 300, tiap potongan di-page sampai habis.
 * Pemakaian: fetchAllChunked(nos, (bagian, a, b) => supabase().from('x').select('...').in('no', bagian).order('no').range(a, b))
 */
export async function fetchAllChunked<T>(
  keys: string[],
  make: (bagian: string[], dari: number, sampai: number) => PromiseLike<PagedResult<T>>,
): Promise<T[]> {
  const out: T[] = [];
  for (let i = 0; i < keys.length; i += 300) {
    const bagian = keys.slice(i, i + 300);
    out.push(...await fetchAllPaged<T>((a, b) => make(bagian, a, b)));
  }
  return out;
}
